import { useQuery } from '@tanstack/react-query';
import { killshotApi } from '../api';

const V1 = 'v1';

export const fetchNotifications = async () => {
  const response = await killshotApi.get(`${V1}/notifications`);
  return response;
};

export const UpdateNotificationRead = async notificationId => {
  return killshotApi.post(`${V1}/notifications/reads`, {
    notification_id: notificationId,
  });
};

export const userQueryGetNotifications = () => {
  const { data, isFetching, status, error, dataUpdatedAt, refetch } = useQuery({
    queryKey: [`/notifications`],
    queryFn: () => fetchNotifications(),
    staleTime: 0,
    refetchOnMount: true,
  });
  return {
    dataNotification: data,
    isFetchingNotification: isFetching,
    status,
    error,
    dataUpdatedAt,
    refetch,
  };
};
